export const capitalizeFirstLetter = (str: string) =>
  str[0].toUpperCase() + str.slice(1);

export const extractLastPath = (url = '') => {
  // URL에서 쿼리스트링을 제외
  const urlWithoutQuery = url.split('?')[0];
  // 정규식을 사용하여 마지막 path 추출
  const match = urlWithoutQuery.match(/\/([^\\/]+)\/?$/);

  if (match && match[1]) {
    return match[1];
  }
  return '';
};

export const isNumeric = (value: string) =>
  /^-?\d+(\.\d+)?$/.test(value.toString());

/**
 * @param {string} str 인코딩할 문자열
 * @returns {string} 특수 문자와 유니코드가 인코딩된 문자열
 * @throws {TypeError} 입력값이 문자열이 아닐 경우
 */
export const encodeSpecialChars = (str: string): string => {
  const text = str.trim();
  try {
    // 입력값 타입 검사
    if (typeof text !== 'string') {
      throw new TypeError('입력값은 문자열이어야 합니다.');
    }
    return encodeURIComponent(text);
  } catch (error: any) {
    console.error('###error', error);
    return text;
  }
};
